//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { Auth } from 'aws-amplify';
import { TMessageMapEntry } from 'aws-amplify-react';
import React from 'react';
import { useSelector } from 'react-redux';

import { getPostLoginRedirect } from 'app/initialization/routing/selectors/getPostLoginRedirect';
import Authenticator from './Authenticator';
import parseUrl from '@utils/parseUrl';
import { LoginFooter } from 'app/login/components/LoginFooter';

const errorMap: TMessageMapEntry[] = [
  ['Incorrect email address or password', /user.*not.*exist/i],
  ['Incorrect email address or password', /exception.*migrating.*user/i],
  ['User already exists', /user.*already.*exist/i],
  ['Incorrect email address or password', /incorrect.*username.*password/i],
  [
    'Invalid password format. Please specify a password of at least 8 characters.',
    /validation.*password/i,
  ],
  [
    'Invalid phone number format. Please use a phone number format of +12345678900',
    /invalid.*phone/i,
  ],
];

// Roughly follows Amplify's default error message mapping
function mapErrorMessage(message) {
  const match = errorMap.filter((e) => e[1].test(message));
  if (match.length === 0) {
    return message;
  }

  const entry = match[0];
  const msg = entry[0];
  return msg;
}

async function onAuthStateChange(
  authState: string,
  redirectTo?: string,
): Promise<void> {
  if (authState === 'signedIn') {
    const session = await Auth.currentSession();
    // TODO: Is this a noop?
    session.getIdToken().getJwtToken();

    // Prevent open redirect: Only accept the redirect target if it matches the current origin.
    if (redirectTo && parseUrl(redirectTo).origin === location.origin) {
      location.assign(redirectTo);
    } else {
      location.assign('/');
    }
  }
}

export const LoginPage = () => {
  const redirectTarget = useSelector(getPostLoginRedirect);
  return (
    <>
      <Authenticator
        // Optionally hard-code an initial state
        authState='signIn'
        // Fired when Authentication State changes
        onStateChange={(authState) =>
          onAuthStateChange(authState, redirectTarget)
        }
        // Error message mapping
        errorMessage={mapErrorMessage}
      />
      <LoginFooter />
    </>
  );
};

export default LoginPage;
